import RegisterNewForm from './RegisterNew';

export default RegisterNewForm;
